module.exports = __webpack_public_path__ + "static/media/mk.5fb44612.svg";